import { ApolloProvider } from '@apollo/client';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import { apolloClientFactory, defaultCache } from '@eluve/apollo-client';
import { lazyRoute } from '@eluve/app-router-utils';
import { LoadingIndicator } from '@eluve/components';

import { appConfig } from '../../../config';
import { tokenProvider } from '../../../session-token-provider';

const evalApolloClient = apolloClientFactory({
  uri: appConfig.VITE_APOLLO_CLIENT_URI,
  desiredRole: 'eval-user',
  cacheInstance: defaultCache,
  accessTokenProvider: tokenProvider,
});

// Deferred: the eval surface is internal-only, so nothing here belongs in the
// bundle that renders the login screen. The route's own <Suspense> covers them.
const EvalGuard = lazyRoute('EvalGuard', () => import('./EvalGuard'));
const EvalLayout = lazyRoute('EvalLayout', () => import('./EvalLayout'));
const SourceArtifactPendingReviewListPage = lazyRoute(
  'SourceArtifactPendingReviewListPage',
  () => import('./SourceArtifactPendingReviewListPage'),
);
const ArtifactDetailsPage = lazyRoute(
  'ArtifactDetailsPage',
  () => import('@eluve/frontend-feature-eval'),
);

export const createEvalRoutes = (path: string) => {
  return [
    {
      path,
      element: (
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          <EvalGuard>
            <Helmet>
              <title>Eval | Eluve</title>
            </Helmet>
            <ApolloProvider client={evalApolloClient}>
              <EvalLayout />
            </ApolloProvider>
          </EvalGuard>
        </Suspense>
      ),
      children: [
        {
          path: 'source-artifact-review',
          element: <SourceArtifactPendingReviewListPage />,
        },
        {
          path: 'source-artifact-review/:artifactId',
          element: <ArtifactDetailsPage />,
        },
      ],
    },
  ];
};
